export const contryListData = [
    {
        country: 'Chile',
        iso2_code: 'CL',
    },
];

export const portalInfoDataTest = [
    {
        portal_id: 1,
        portal_name: "Jumbo S.A Cencosud",
        portal_link: "http://www.jumbo.cl/b2b",
        portal_country: "CL",
    },
    {
        portal_id: 2,
        portal_name: "Falabella",
        portal_link: "http://www.falabella.com/b2b",
        portal_country: "CL",
    },
    {
        portal_id: 3,
        portal_name: "Walmart",
        portal_link: "http://www.walmart.cl/b2b",
        portal_country: "CL",
    },
];

export const doNotFoundPortals = [
    {
        portal_id: null,
        portal_name: "",
        portal_link: "",
        portal_country: "",
    },
];
